// Plugin chart.js (v2) que desenha o valor de cada data point no gráfico.
// Suporta bar, line, doughnut e pie.

function fmt(v) {
  const n = Number(v);
  if (!isFinite(n)) return "";
  if (Math.abs(n) >= 1000) {
    return (
      (n / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + "k"
    );
  }
  return n.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
}

// Acima desse nº de pontos por série, não desenha rótulos (evita poluição
// em gráficos diários). O tooltip continua no hover.
const MAX_POINTS = 13;

export default {
  id: "dashDataLabels",
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    if (!ctx) return;
    const type = chart.config.type;
    const isArc = type === "doughnut" || type === "pie";

    ctx.save();
    ctx.font = "600 10px -apple-system, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    chart.data.datasets.forEach((dataset, di) => {
      const meta = chart.getDatasetMeta(di);
      if (meta.hidden) return;
      if (!isArc && meta.data.length > MAX_POINTS) return;

      meta.data.forEach((element, index) => {
        const value = dataset.data[index];
        if (value == null || value === "") return;
        const model = element._model;
        if (!model) return;
        const label = fmt(value);

        if (isArc) {
          if (Number(value) === 0) return;
          const mid = (model.startAngle + model.endAngle) / 2;
          const r = (model.innerRadius + model.outerRadius) / 2;
          const x = model.x + Math.cos(mid) * r;
          const y = model.y + Math.sin(mid) * r;
          ctx.fillStyle = "#fff";
          ctx.fillText(label, x, y);
        } else {
          const x = model.x;
          const y = type === "bar" ? model.y - 9 : model.y - 10;
          ctx.fillStyle = "#495057";
          ctx.fillText(label, x, y);
        }
      });
    });

    // Total no centro do donut/pizza
    if (isArc && chart.data.datasets.length) {
      const ds0 = chart.data.datasets[0];
      const total = (ds0.data || []).reduce(
        (a, b) => a + (Number(b) || 0),
        0
      );
      const ca = chart.chartArea;
      if (ca) {
        const cx = (ca.left + ca.right) / 2;
        const cy = (ca.top + ca.bottom) / 2;
        ctx.fillStyle = "#95aac9";
        ctx.font = "600 10px -apple-system, sans-serif";
        ctx.fillText("TOTAL", cx, cy - 12);
        ctx.fillStyle = "#12263f";
        ctx.font = "700 18px -apple-system, sans-serif";
        ctx.fillText(total.toLocaleString("pt-BR"), cx, cy + 6);
      }
    }

    ctx.restore();
  },
};
